<!-- 0706022393 -->
<template>
	<div class="d-flex flex-column justify-content-center" :style="{ height: inset_height}">
		<div class="d-flex justify-content-center">	
			<div class="w-35 shadow p-4 rounded">     
				<h2 v-if="! inset" class="mb-5 text-success"> Vidduka | Login</h2>           			
				<ul v-if="login_error.length" class="text-center list-unstyled">
					<li v-for="error in login_error" :key="error">
						<small class="text-danger">{{ error }}</small>
					</li>
				</ul>
	
				<ul v-if="login_info.length" class="text-center list-unstyled">
					<li v-for="error in login_info" :key="error" class="text-info">
						<small>{{ error }}</small>
					</li>
				</ul>
	
				<div class="form-group">
					<label v-if="! inset" for="phone">Phone Number</label>
					<input type="text" class="form-control"
							id="phone" placeholder="phone number" 
							v-model="phone_number"
							@keyup.enter="getToken()">
				</div>
				<div class="form-group">
					<label v-if="! inset" for="password">Password</label>
					<input type="password" class="form-control"
							id="password" placeholder="password"
							v-model="password"
							@keyup.enter="getToken()">
					<br>
				</div>				
				<!-- /.submit button -->
				<div class="" @keyup.enter="getToken()">
					<button class="btn btn-success btn-block btn-flat"
						@click="getToken()">
						Log In
					</button>
				</div>
				<!-- /.col -->		
				<div v-if="! inset" class="p-5 d-flex flex-column">					
					<router-link to="reset-password" class="text-center">
						Forgot password ??
					</router-link>
					<router-link to="register" class="text-center">
						Don't have an account? Create one now!
					</router-link>
				</div>						
			</div>
		</div>
	</div>   
</template>
<script>
export default {
	name: 'login',
	props:{
		inset:{
			type: Boolean,
			default: false
		},
		inset_height:{
			type:String,
			default: "100vh"
		}
	},
	data() {
	return {     
		//form data   				
		phone_number: null,
		password: null,
		//view state
		login_error: [],
		login_info: [],
		//logged in user
		logged_in_user:null,
		logged_in_user_location_id:null
	}
	},	
	methods: {	
	//get access token
	getToken: function () { 
		//clear errors and info   		
		this.login_info = []
		this.login_error = []
		//get token from network
		this.login_info.push("authenticating...")		
		this.$http({
			method: 'post',
			url: this.$API_BASE_URL + '/HJYBCFRB/api-token-auth/',
			data: {
				phone_number: this.phone_number.replace(/\s/g, ""),//replace white spaces with nothind
				password: this.password
			}
			}).then((response) => {
				var response_data = response.data
				//clear errors and info
				this.login_info = []
				this.login_error = []  
				//update view state
				this.logged_in_user = response_data.user
				this.logged_in_user_location_id = response_data.location_id				
				//update local storage 				
				localStorage.setItem(
					'logged_in_user',
					JSON.stringify(response_data.user)
				)
				localStorage.setItem(
					'logged_in_user_location_id',
					JSON.stringify(response_data.location_id)
				)    	
				localStorage.setItem(
					'auth_token',
					JSON.stringify(response_data.token)
				) 		
				localStorage.setItem(
					'auth_code',
					JSON.stringify(response_data.user.authorizationCode)
				) 		
				localStorage.setItem(
					'reports_auth_code',
					JSON.stringify(response_data.user.reportsAuthorizationCode)
				)
				this.$store.commit('log_in_user',response_data.user)
				//inform app.vue of new logged in user
				this.$store.commit('switch_account')
				this.emitToParent()

			}).catch((err) => {
				//clear errors and info
				this.login_info = []
				this.login_error = []
				//if error has no response,
				if(! err.response){
					this.login_error.push(err)
				}
				//error has a response
				else{					
					this.login_error.push("Invalid credentials")
					if (this.inset){
						alert('Invalid credentials')
					}
				}
			})
	},
	//inform App.vue of a new login
	emitToParent () {
		this.$emit('newLogin', this.logged_in_user)
	},
	}
}
</script>